/**
 * Read the active caption language from a video editor's KaraokeConfig,
 * normalizing the absent / sentinel cases to `ORIGINAL_LANGUAGE` so
 * downstream callers only have to special-case one value via
 * `isOriginalLang`.
 *
 * Used at three sites (PLAT-9966): the Creator Studio + clip-preview
 * outbound-transform installs and the modal extraction reaction.
 * Centralising the read keeps the normalisation contract single-source —
 * future migrations of the karaoke config off of the plain `VideoEditor`
 * class can swap this helper without touching all three callers.
 */
import { ORIGINAL_LANGUAGE } from '@src/utility/captionLanguage';

interface KaraokeConfigLike {
  language?: string | null;
}

interface EditorLike {
  getDefaultKaraokeConfig: () => KaraokeConfigLike | null | undefined;
}

export function readActiveCaptionLanguage(
  editor: EditorLike | null | undefined,
): string {
  return editor?.getDefaultKaraokeConfig()?.language ?? ORIGINAL_LANGUAGE;
}
